import React, { useContext } from 'react';
import { Link } from 'gatsby';
import {
  ListGroup,
  Card,
  CardBody,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Row,
  Col,
} from 'reactstrap';

import { toGetStarted, toBrowseJobsByState } from '../../routes';
import { isEmpty } from '../../utils/jsHelper';
import JobPostingListItem from './JobPostingListItem';
import JobSearchInputBlock from '../search/JobSearchInputBlock';
import JobIndexAside from '../common/JobIndexAside';
import { GlobalContext } from '../../context/GlobalContext';

const JobsPostingList = (props) => {
  const {
    jobs,
    header,
    h2,
    content,
    similarPositionsLinks,
    matchingSalariesLinks,
    synonymsLinks,
  } = props;
  const { breadcrumbs } = props.pageContext;
  const {
    userAuth: { isAuthenticated },
  } = useContext(GlobalContext);
  return (
    <>
      <div className="jumbotron bg-secondary text-white text-center">
        <h1>{header}</h1>
        <p>{content}</p>
        {!isAuthenticated && (
          <Button tag={Link} to={toGetStarted} color="primary">
            Register Now
          </Button>
        )}
      </div>
      <Container className="mb-3">
        <Row>
          <Col>
            <Breadcrumb>
              <BreadcrumbItem tag={Link} to={toBrowseJobsByState}>
                All Job Postings
              </BreadcrumbItem>
              {breadcrumbs &&
                breadcrumbs.map((link, index) => (
                  <BreadcrumbItem
                    active={!link.link}
                    key={index}
                    tag={link.link ? Link : 'span'}
                    to={link.link}
                  >
                    {link.label}
                  </BreadcrumbItem>
                ))}
            </Breadcrumb>
            <JobSearchInputBlock classNames="mb-5 w-100" header={h2} />
          </Col>
        </Row>
        <Row className="position-relative">
          {isEmpty(jobs) ? (
            <Col>
              <Card>
                <CardBody>No jobs matched your criteria.</CardBody>
              </Card>
            </Col>
          ) : (
            <Col xs="12" md="9">
              <ListGroup>
                {jobs.map((edge, index) => (
                  <JobPostingListItem
                    job={edge.node}
                    key={'job' + (edge.node.jobId + edge.node.jobKey)}
                  />
                ))}
              </ListGroup>
            </Col>
          )}
          {(props.similarPositionsLinks.length > 0 ||
            props.matchingSalariesLinks.length > 0 ||
            props.synonymsLinks.length > 0) && (
            <Col
              tag="aside"
              xs="6"
              md="3"
              className="mt-3 mt-md-0 position-sticky"
              style={{ alignSelf: 'flex-start', top: '100px' }}
            >
              <hr className="d-md-none" />
              <JobIndexAside
                similarPositionsLinks={similarPositionsLinks}
                matchingSalariesLinks={matchingSalariesLinks}
                synonymsLinks={synonymsLinks}
              />
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
};

export default JobsPostingList;
